<template>
    <div>
        <!--
                - у миниатюр с видео есть класс item--video и блок item__play
                - при клике открывается модалка с видео с параметрами, как на главной
            -->
        <popup v-if="type==='video'" :width="992" @close="close" :show="modal" :add-class="'popup--video'">
            <iframe width="992"
                    height="548"
                    :src="'https://www.youtube.com/embed/'+currentId"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
        </popup>
        <div v-if="countItems > 1 && type == 'photo-review'" class="review__photos">
            <div class="item" v-for="(item,index) in viewerImages" :class="{'hide': index > 3}"
                 @click="showViewer(index)">
                <a href="javascript:void(0);" v-if="item.mediaType == 'photo'"
                   :style="{'background-image': 'url('+appPath+item.icon+')'}"></a>
                <div class="overlay-count" v-if="viewerImages.length > 3 && index === 3">
                    Ещё {{viewerImages.length - 3}}
                </div>
            </div>
        </div>
        <div v-if="countItems > 0 && type == 'photo-rule'" class="rule__photos">
            <div class="item" v-for="(item,index) in viewerImages"
                 @click="showViewer(index)" :key="'photo_rule'+index">
                <a href="javascript:void(0);" v-if="item.mediaType == 'photo'"
                   :style="{'background-image': 'url('+appPath+item.icon+')'}">
                       <div class="num">
                           {{index+1}}
                       </div>
                   </a>
            </div>
        </div>
        <div v-else-if="countItems > 4 && type != 'photo-coupons'" class="action-detail__carousel">

            <hooper ref="carousel" class="carousel-thumbs" :class="{'carousel-thumbs--video':type === 'video'}"
                    :wheelControl="false" :itemsToShow="4" :centerMode="false" :trimWhiteSpace="true">
                <slide :key="index"
                       v-for="(item,index) in items">
                    <div v-if="type === 'photo'"
                         class="item">
                        <a @click="showViewer(index+1)"
                           href="javascript:void(0)"
                           :style="{'background-image': 'url('+appPath+item.icon+')'}"></a>
                    </div>


                    <div v-else class="item item--video">
                        <a @click="showVideo(item)" href="javascript:void(0)"
                           :style="{'background-image': 'url('+item.preview+')'}">
                            <span class="item__play"></span>
                        </a>
                    </div>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
        </div>

        <div v-else-if="countItems > 1 && type == 'photo-coupons'" class="action-detail__carousel detail-carousel">
            <hooper ref="detail-carousel" class="carousel-thumbs carousel-detail"
                    :class="{'carousel-thumbs--video':type === 'video'}" :wheelControl="false" :itemsToShow="1"
                    :centerMode="false" :trimWhiteSpace="true" @slide="checkVideo" :infiniteScroll="true">
                <slide :key="index"
                       v-for="(item,index) in viewerImages">
                    <div v-if="item.mediaType == 'photo'"
                         class="item">
                        <a @click="showViewer(index)"
                           href="javascript:void(0)"
                           :style="{'background-image': 'url('+appPath+item.icon+')'}"></a>
                    </div>

                    <div class="item" v-else>
                        <iframe width="1100"
                                height="450"
                                :src="'https://www.youtube.com/embed/'+item.embedId+'?enablejsapi=1'"
                                frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                    </div>
                </slide>
                <div class="fullscreen-btn" slot="hooper-addons" v-show="showFullscreen"
                     @click="showViewer(currentSlide)"></div>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
            <div class="right-preview">
                <div class="item" v-for="(item,index) in viewerImages" :class="{'hide': index > 4 || index == 0}"
                     @click="showViewer(index)">
                    <a href="javascript:void(0);" v-if="item.mediaType == 'photo'"
                       :style="{'background-image': 'url('+appPath+item.icon+')'}"></a>
                    <a href="javascript:void(0);" v-else
                       :style="{'background-image': 'url(//img.youtube.com/vi/'+item.embedId+'/0.jpg)'}">
                        <img src="@/assets/img/play.svg" alt="">
                    </a>
                    <div class="overlay-count" v-if="viewerImages.length > 4 && index === 4">
                        Ещё {{viewerImages.length - 4}}
                    </div>
                </div>
            </div>
        </div>


        <div class="gallery-thumbnail-list" v-else>
            <div
                    :class="['col-'+colItems,type === 'photo'?'gallery-item':'item--video']"
                    class="item"
                    :key="index"
                    v-for="(item,index) in items">
                <a v-if="type === 'photo'"
                   @click="showViewer(index+1)"
                   href="javascript:void(0)"
                   :style="{'background-image': 'url('+appPath+item.icon+')'}"></a>

                <a v-else @click="showVideo(item)"
                   href="javascript:void(0)"
                   :style="{'background-image': 'url('+item.preview+')'}">
                    <span class="item__play"></span>
                </a>
            </div>
        </div>

        <div class="viewer-container viewer-backdrop viewer-fixed viewer-hooper viewer-fade"
             v-if="type === 'photo' || type === 'photo-coupons' || type === 'photo-review' || type == 'photo-rule' && ruleViewerShow" ref="viewer"
             @keyup.space="slideNext" @keyup.esc="closeViewer" >

            <div class="viewer-canvas-wrapper">

                <div class="viewer-canvas">
                    <hooper class="carousel-thumbs viewer-carousel" ref="viewerHooper" @slide="checkVideoViewer" :infiniteScroll="true">
                        <slide :key="index"
                               v-for="(item,index) in viewerImages">
                            <div class="item" v-if="item.mediaType == 'photo'">
                                <img v-if="isPartner" :src="appPath+item.watermark" alt="">
                                <img v-else :src="appPath+item.path" alt="">
                            </div>
                            <div class="item" v-else>
                                <iframe width="1100"
                                        height="450"
                                        :src="'https://www.youtube.com/embed/'+item.embedId+'?enablejsapi=1'"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                            </div>
                        </slide>

                        <hooper-navigation slot="hooper-addons"></hooper-navigation>
                    </hooper>
                </div>
                <div role="button" class="viewer-button viewer-close" @click="closeViewer"></div>

                <div class="photo-num" v-if="type == 'photo-rule'">
                    1
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Popup from '@/components/modal/Popup.vue';
    import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper'; // carousel


    export default {
        name: "Gallery",
        components: {
            Hooper,
            Slide,
            HooperNavigation,
            Popup
        },
        props: {
            type: {
                default: 'photo', // video
            },
            items: {
                default() {
                    return [];
                }
            },
            firstphoto: {
                default() {
                    return false;
                }
            },
            showFirstPhoto: {
                default() {
                    return false;
                }
            },
            moderator: {
                default() {
                    return false;
                }
            },
            infiniteScroll: {
                default() {
                    return true;
                }
            },
        },
        data() {
            return {
                currentId: false,
                modal: false,
                viewerShow: false,
                unsubscribe: '',
                showFullscreen: true,
                currentSlide: '',
                isShowedViewer: false,
                ruleViewerShow: false,
                appPath: process.env.VUE_APP_PATH_BACK,
            }
        },
        watch: {
            showFirstPhoto: function () {
                this.showViewer(0);
            }
        },
        beforeMount() {
            this.$nextTick(function () {
                this.viewerShow = true;
            });
        },
        mounted: function () {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type == 'setTabClick') {
                    this.updateCarousel();
                }
            });
        },
        beforeDestroy: function () {
            this.unsubscribe();
        },
        computed: {
            isPartner() {
                let path = this.$route.path.split('/');
                return path[1] === 'partner'
            },
            currentCode() {
                return this.viewerImages[this.currentSlide].code
            },
            ...mapState({
                popups: state => state.popups.items,
            }),
            countItems() {
                return this.items.length;
            },
            colItems() {
                let col = 6;
                switch (this.countItems) {
                    case 1:
                        col = 24;
                        break;
                    case 2:
                        col = 12;
                        break;
                    case 3:
                        col = 8;
                        break;
                }
                return col;
            },
            viewerImages() {
                let images = [];
                for (let item in this.items) {

                    images.push(this.items[item])
                }
                return images;
            }
        },
        methods: {
            checkVideoViewer(payload) {
                let currentSlide = payload.currentSlide;
                this.currentSlide = payload.currentSlide;
                if (typeof(this.viewerImages[currentSlide]) !== 'undefined' && this.viewerImages[currentSlide].mediaType != 'video') {
                    this.pauseVideos();
                }
            },
            checkVideo(payload) {
                this.currentSlide = payload.currentSlide;
                if (this.viewerImages[this.currentSlide].mediaType != 'video') {
                    this.pauseVideos();
                    this.showFullscreen = true;
                } else {
                    this.showFullscreen = false;
                }
            },
            close() {
                this.modal = false;
            },
            showVideo(item) {
                this.currentId = item.id;
                let self = this;
                setTimeout(function () {
                    self.modal = true;
                }, 10);
            },
            closeViewer() {
                if (this.isShowedViewer) {
                    this.$refs.viewer.classList.add('viewer-transition');
                    this.$refs.viewer.classList.remove('viewer-in');
                    document.getElementsByTagName('body')[0].classList.remove("noscroll");
                    let self = this;
                    setTimeout(function () {
                        if (self.$refs.viewer) {
                            self.$refs.viewer.classList.remove('viewer-transition');
                        }
                        if (self.$refs.viewerHooper) {
                            self.$refs.viewerHooper.restart();
                        }
                        self.pauseVideos();
                        self.isShowedViewer = false;
                        this.ruleViewerShow = false;
                    }, 200);
                }
            },
            pauseVideos() {
                [...document.getElementsByTagName('iframe')].forEach(i => i.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
            },
            isShowViewer() {
                return document.querySelector('.viewer-container').classList.contains('viewer-in');
            },
            slideNext() {
                this.$refs.viewerHooper.slideNext();
            },
            showViewer(index) {
                this.ruleViewerShow = true;
                let self = this;
                setTimeout(function () {
                    self.$refs.viewer.classList.remove('viewer-transition');
                    self.$refs.viewer.classList.remove('opening');
                }, 400);
                setTimeout(function () {
                    self.$refs.viewer.classList.add('opening');
                    self.$refs.viewerHooper.slideTo(index);
                    self.$refs.viewer.classList.add('viewer-transition');
                    self.$refs.viewer.querySelector('.hooper-track').setAttribute('tabindex', 0);
                    self.$refs.viewer.classList.add('viewer-in');
                    document.getElementsByTagName('body')[0].classList.add("noscroll");
                    self.isShowedViewer = true;
                    self.$refs.viewer.querySelector('.hooper-track').focus();
                }, 10);
            },
            updateCarousel() {
                if (this.$refs.carousel) {
                    setTimeout(() => {
                        if (this.$refs.carousel !== undefined) {
                            this.$refs.carousel.updateWidth();
                        }
                    }, 3);
                }
            }
        },
        directives: {
            'clickoutside': {
                bind: function (el, binding, vNode) {
                    if (typeof binding.value !== 'function') {
                        const compName = vNode.context.name;
                        let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                        if (compName) {
                            warn += `Found in component '${compName}'`
                        }
                        //console.warn(warn);
                    }
                    const bubble = binding.modifiers.bubble;
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target) && (!e.target.classList.contains('click-outside-tooltip'))) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler;
                    document.addEventListener('click', handler);
                },

                unbind: function (el, binding) {
                    document.removeEventListener('click', el.__vueClickOutside__);
                    el.__vueClickOutside__ = null;
                }
            }
        }
    }
</script>

<style scoped>

</style>
